const PopupActionTypes = {
  TOGGLE_FEEDBACK_POPUP_HIDDEN: 'TOGGLE_FEEDBACK_POPUP_HIDDEN'
};

export default PopupActionTypes;



// WEBPACK FOOTER //
// ./src/actions/PopupTypes.js